var addEvent = function(e, t, n) {
    if (e == null || e == undefined) return;
    if (e.addEventListener) {
        e.addEventListener(t, n, false)
    } else if (e.attachEvent) {
        e.attachEvent("on" + t, n)
    }
};
var removeEvent = function(elem, type, eventHandle) {
    if (elem == null || elem == undefined) return;
    if (elem.removeEventListener) {
        elem.removeEventListener(type, eventHandle, false);
    } else if (elem.attachEvent) {
        elem.detachEvent("on" + type, eventHandle);
    }
};
var waitForFinalEvent = (function() {
    var timers = {};
    return function(callback, ms, uniqueId) {
        if (!uniqueId) {
            uniqueId = "Don't call this twice without a uniqueId";
        }
        if (timers[uniqueId]) {
            clearTimeout(timers[uniqueId]);
        }
        timers[uniqueId] = setTimeout(callback, ms);
    };
})();

const styles = ['font-size: 14px', 'color: #ffffff', 'background-color: #7FA113', 'padding: 4px 0px 4px 8px'].join(';')
    , brandStyles = ['font-size: 14px', 'color: #ffffff', 'background-color: #293133', 'padding: 4px 8px 4px 8px', 'font-weight: bold'].join(';')
    , text = '%cMade by %cW3design https://www.w3design.it/';
console.log(text, styles, brandStyles);

addEvent(window, "load", function() {

});
addEvent(window, "resize", function() {
    /*waitForFinalEvent(function(){
        alert('Resize...');
        //...
    }, 500, "some unique string");*/
});

if($("#contact-form").length>0) {
    $("#contact-form form").validate({
        rules: {
            first_name: {
                required: true
            },
            last_name: {
                required: true
            },
            email: {
                email: true
            },
            privacy: {
                required: true
            },
        },
        messages: {
            first_name: "Campo obbligatorio",
            last_name: "Campo obbligatorio",
            email: "Campo obbligatorio",
            privacy: "Campo obbligatorio",
        }
    });
}

$(window).scroll(function() {
    if ($(this).scrollTop() > 350) {
        $('.scroll-top').fadeIn();
    }else{
        $('.scroll-top').fadeOut();
    }
});


$('.scroll-top').click(function (e) {
    e.preventDefault();
    $("html, body").animate({scrollTop:0}, 'slow');
})
$('.js-goToPos').click(function (e) {
    e.preventDefault();
    let newPos = $(this).attr('href');
    $("html, body").animate({
        scrollTop: $(newPos).offset().top - 20
    }, 'slow');
})

$('.hamburger').click(function() {
    $(this).toggleClass("is-active");
    $('.menu-wrapper').toggleClass("open");
    $('body').toggleClass("menu-open");
});

if($("#info-msg").length>0) {
    $('#info-msg').show(function () {
        $(".chiudi").click(function(e){
            e.preventDefault();
            $('#info-msg').hide();
            $('.overlay-popup').hide();
        })
    });
}

import imagesLoaded from 'imagesloaded';

if($('.gallery-prod').length>0 && $(window).width() > 640) {
    imagesLoaded(document.querySelector('.gallery-prod'), function () {
        let $carousel_gallery = $('.gallery-prod');
        $('.gallery-prod').owlCarousel({
            margin: 30,
            loop: false,
            autoWidth: true,
            items: 4,
            dots: false,
            nav: false,
        });

        $('#gal-next').on('click', function (e) {
            e.preventDefault();
            $carousel_gallery.trigger('next.owl.carousel');
        });

        $('#gal-back').on('click', function (e) {
            e.preventDefault();
            $carousel_gallery.trigger('prev.owl.carousel');
        });
    });
}

if($('.correlati-prod').length>0) {
    imagesLoaded(document.querySelector('.correlati-prod'), function () {
        let $carousel_correlati = $('.correlati-prod');
        $('.correlati-prod').owlCarousel({
            margin: 30,
            loop: false,
            items: 4,
            dots: false,
            nav: false,
            responsive : {
                // breakpoint from 0 up
                0 : {
                    items: 1,
                },
                // breakpoint from 480 up
                360 : {
                    items: 2,
                },
                // breakpoint from 768 up
                768 : {
                    items: 4,
                }
            }
        });
        $('#correlato-next').on('click', function (e) {
            e.preventDefault();
            $carousel_correlati.trigger('next.owl.carousel');
        });

        $('#correlato-back').on('click', function (e) {
            e.preventDefault();
            $carousel_correlati.trigger('prev.owl.carousel');
        });
    });
}

if($('.list-slide-sostenibilita').length>0) {
    imagesLoaded(document.querySelector('.list-slide-sostenibilita'), function () {
        let $carousel_sostenibilita = $('.list-slide-sostenibilita');
        $carousel_sostenibilita.owlCarousel({
            margin: 0,
            loop: true,
            items: 1,
            center: true,
            dots: false,
            nav: false,
        });
        $('#sostenibilita-next').on('click', function (e) {
            e.preventDefault();
            $carousel_sostenibilita.trigger('next.owl.carousel');
        });

        $('#sostenibilita-back').on('click', function (e) {
            e.preventDefault();
            $carousel_sostenibilita.trigger('prev.owl.carousel');
        });
    });
}
$('.singola-finitura').mouseover(function (){
    let $finitura = $(this).data('finitura');
    if($finitura == undefined || $finitura == null || $finitura == "") return;
    $('.singola-variante-colore').hide();
    $('#'+$finitura).show();
}).mouseleave(function (){
    $('.other-color').hide();
    $('.first-color').show();
})

if($('.container-filter_prolab').length>0) {
    var Scrollbar = window.Scrollbar;
    Scrollbar.init(document.querySelector('.container-filter_prolab'));
}

$('#js-open-filter').click(function (e) {
    e.preventDefault();
    $('.wrapper-filter_prolab').toggleClass('active');
    $('body').toggleClass('prolab_filter_open');
});
$('.close-filter_prolab').click(function (e) {
    $('.wrapper-filter_prolab').toggleClass('active');
    $('body').toggleClass('prolab_filter_open');
})

$('.title-filter_prolab').click(function (e) {
   $(this).parents('.single-filter_prolab').find('.list-of-filter_prolab').slideToggle();
});


/* Rete vendita */
if($(".rete-vendita").length>0) {

    var inizio=$(".reg").html();

    var region_data;
    inizializza();

    function inizializza(){

        for(var i = 0; i < regions.length; i++) {
            $('#'+ regions[i].region_code + ", #a_"+ regions[i].region_code)
                .data('region', regions[i]).data('id', regions[i].region_id);
        }

        $('.map-svg g').mouseover(function (e) {
            region_data=$(this).data('region');
            //alert(region_data.region_code);
            $(".regioni a#a_"+region_data.region_code).addClass("over");
        })
            .mouseleave(function () {
                $(".regioni a").removeClass("over");
            });

        $('.regioni a').mouseover(function (e) {
            region_data=$(this).data('region');
            $(".map-svg g#"+region_data.region_code).attr("class", "over");
        })
            .mouseleave(function () {
                $(".map-svg g").attr("class", "over_");
            });

        $('.map-svg g, .regioni a').on('touchend click', function(e) {

            var region_data=$(this).data('region');
            var region_data_id=$(this).data('id');

            $(".map-svg g, .regioni a").attr("class", "over_").removeAttr("style");
            $(".map-svg g#"+region_data.region_code).css({fill:"#000000"});

            //console.log(region_data.region_code);

            //CHIAMATA AJAX

            $.ajax({
                type: 'GET',
                url: '/retailers/'+region_data_id+'/retailers-by-province',
                //data: { regione: region_data.region_code },
                dataType: 'json',
                beforeSend: function( ) {
                    $(".loading").show();
                    $(".reg").html("");
                }
            }).done(function(data) {

                var html="";

                html+='<ol class="breadcrumb">';
                html+='    <li><a href="javascript:void(0)" class="return">'+msg[0].txt_italy+'</a></li>';
                html+='    <li class="active">'+data.regione+'</li>';
                html+='</ol>';

                html+='<div class="elenco-info">';
                html+='<div class="wrapper-inner flex">';

                html+='<div class="block x-full">';

                html+='<ul class="accordion">';

                $.each(data.province, function(index, element) {
                    html+='<li>';
                    html+='<a href="javascript:void(0)" class="js-accordion-trigger">' + element.nome + '<i class="fa fa-angle-down"></i></a>';
                    html+='<div class="submenu_accordion">';

                    if(element.rivenditori.length > 0){
                        $.each(element.rivenditori, function (index, child) {
                            //html += '<h4>' + msg[0][index_type] + '</h4>';
                            html += '<p>';
                            html += '<strong>' + child.name + '</strong><br>';
                            if (child.address) {
                                html += child.address+'<br>';
                            }
                            html += msg[0].txt_telefono + ' ' + child.telephone;
                            if (child.fax) {
                                html += ' ' + msg[0].txt_fax + ' ' + child.fax;
                            }
                            html += '<br>';
                            html += msg[0].txt_mail + ': <a href="mailto:' + child.email + '">' + child.email + '</a>';
                            html += '</p>';
                        });
                    }
                    else {
                        html+= '<p>'+msg[0].no_rivenditori+'</p>';
                    }

                    html+='</div>';
                    html+='</li>';
                });
                html+='</ul>';

                html+='</div>';
                html+='</div>';
                html+='</div>';
                html+='</div>';

                $(".reg").html(html);
                $(".loading").hide();

                /*--------------------*/
                /*--------------------*/
                /*--------------------*/

                $('.js-accordion-trigger').bind('click', function(e){
                    $("#aperto").attr('id', '');
                    $(".fa").removeClass('fa-angle-up').addClass('fa-angle-down');
                    $('.accordion .submenu_accordion').hide();
                    $(this).parent().attr('id', 'aperto');
                    $(this).find('.fa').removeClass('fa-angle-down').addClass('fa-angle-up')
                    $(this).parent().find('.submenu_accordion').show();
                });

                $(".return").click(function(){
                    $(".map-svg g, .regioni a").attr("class", "over_").removeAttr("style");
                    $(".reg").html(inizio);
                    inizializza();
                })
            });
        });

    }
}

/* Rete vendita estera */
if($(".rete-vendita-estera").length>0) {

    var inizio_continenti=$(".reg").html();
    // Sistema i soliti casini di Explorer
    /*if($("#Livello_1").length>0) {
        if($(".map-svg").is(":visible") ) {
            $(".map-svg").css({"height": $(".map-svg").width()*1.266 });

            $(window).resize(function(){
                $(".map-svg").css({"height": $(".map-svg").width()*1.266 });
            })
        }
    }*/

    var continent_data;
    inizializzaContinente();

    function inizializzaContinente(){
        var i;
        for(i = 0; i < continent.length; i++) {

            $('#'+ continent[i].continent_code + ", #a_"+ continent[i].continent_code)
                .data('region', continent[i]).data('id', continent[i].continent_id);
        }

        $('.map-svg g').mouseover(function (e) {
            continent_data=$(this).data('region');
            //alert(region_data.region_code);
            $(".regioni a#a_"+continent_data.continent_code).addClass("over");
        })
            .mouseleave(function () {
                $(".regioni a").removeClass("over");
            });

        $('.regioni a').mouseover(function (e) {
            continent_data=$(this).data('region');
            $(".map-svg g#"+continent_data.continent_code).attr("class", "over");
        })
            .mouseleave(function () {
                $(".map-svg g").attr("class", "over_");
            });

        $('.map-svg g, .regioni a').on('touchend click', function(e) {

            continent_data=$(this).data('region');
            let continent_data_id;
            continent_data_id=$(this).data('id');

            $(".map-svg g, .regioni a").attr("class", "over_").removeAttr("style");
            $(".map-svg g#"+continent_data.continent_code).css({fill:"#000000"});

            //console.log(region_data.region_code);

            //CHIAMATA AJAX

            $.ajax({
                type: 'GET',
                url: '/continents/'+continent_data_id+'/retailers-by-country',
                //data: { regione: region_data.region_code },
                dataType: 'json',
                beforeSend: function( ) {
                    $(".loading").show();
                    $(".reg").html("");
                }
            }).done(function(data) {
                var html="";

                html+='<ol class="breadcrumb">';
                html+='    <li><a href="javascript:void(0)" class="return">'+msg[0].txt_world+'</a></li>';
                html+='    <li class="active">'+data.continente+'</li>';
                html+='</ol>';

                html+='<div class="elenco-info">';
                html+='<div class="wrapper-inner flex">';

                html+='<div class="block x-full">';

                if(data.stati.length > 0) {
                    html += '<ul class="accordion">';
                    $.each(data.stati, function (index, element) {
                        html += '<li>';
                        html += '<a href="javascript:void(0)" class="js-accordion-trigger">' + element.nome + '<i class="fa fa-angle-down"></i></a>';
                        html += '<div class="submenu_accordion">';

                        if (element.rivenditori.length > 0) {
                            $.each(element.rivenditori, function (index, child) {
                                //html += '<h4>' + msg[0][index_type] + '</h4>';
                                html += '<p>';
                                if (child.type['it']) {
                                    html += child.type['it'] + '<br>';
                                }
                                html += '<strong>' + child.name + '</strong><br>';
                                if (child.address) {
                                    html += child.address + '<br>';
                                }
                                html += msg[0].txt_telefono + ' ' + child.telephone;
                                if (child.fax) {
                                    html += ' ' + msg[0].txt_fax + ' ' + child.fax;
                                }
                                html += '<br>';
                                html += msg[0].txt_mail + ': <a href="mailto:' + child.email + '">' + child.email + '</a>';
                                html += '</p>';
                            });
                        } else {
                            html += '<p>' + msg[0].no_rivenditori + '</p>';
                        }

                        html += '</div>';
                        html += '</li>';
                    });
                    html += '</ul>';
                }else{
                    html += '<p>' + msg[0].no_rivenditori_world + '</p>';
                }

                html+='</div>';
                html+='</div>';
                html+='</div>';
                html+='</div>';

                $(".reg").html(html);
                $(".loading").hide();

                /*--------------------*/
                /*--------------------*/
                /*--------------------*/

                $('.js-accordion-trigger').bind('click', function(e){
                    $("#aperto").attr('id', '');
                    $(".fa").removeClass('fa-angle-up').addClass('fa-angle-down');
                    $('.accordion .submenu_accordion').hide();
                    $(this).parent().attr('id', 'aperto');
                    $(this).find('.fa').removeClass('fa-angle-down').addClass('fa-angle-up')
                    $(this).parent().find('.submenu_accordion').show();
                });

                $(".return").click(function(){
                    $(".map-svg g, .regioni a").attr("class", "over_").removeAttr("style");
                    $(".reg").html(inizio_continenti);
                    inizializzaContinente();
                })
            });
        });

    }
}

import LazyLoad from 'vanilla-lazyload';
window.lazyLoadInstance = new LazyLoad({
    // Your custom settings go here
});


var videoSlider = $('.owl-carousel-video');
videoSlider.owlCarousel({
    loop: true,
    margin: 0,
    nav: true,
    dots: true,
    autoplay: false,
    items: 1
});

videoSlider.on('translate.owl.carousel', function(e) {
    $('.owl-item .item video').each(function() {
        // pause playing video - after sliding
        $(this).get(0).pause();
    });
});

videoSlider.on('translated.owl.carousel', function(e) {
    // check: does the slide have a video?
    if ($('.owl-item.active').find('video').length !== 0) {
        // play video in active slide
        $('.owl-item.active .item video').get(0).play();


    }
});

$(".video-item").on('ended', myHandler)
function myHandler(ev) {
    // there is no method 'next'
    // so we will fake a click
    $('.owl-next').trigger('click');
}

document.addEventListener("DOMContentLoaded", function () {
    if($(window).width()>640) {
        const videos = document.querySelectorAll("video");

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                const video = entry.target;
                if (entry.isIntersecting) {
                    // Se vuoi che riparta quando rientra nella viewport
                    video.play();
                } else {
                    video.pause();
                }
            });
        }, {
            threshold: 0.5 // almeno metà visibile
        });

        videos.forEach(video => {
            observer.observe(video);
        });
    }else{

    }



    document.querySelectorAll('.download-zip-link').forEach(function (link) {
        link.addEventListener('click', function (e) {
            e.preventDefault();
            const productId = this.dataset.productId;
            downloadZip(productId);
        });
    });
});

$('.has-preview').each(function (el) {
    $(this).click(function (){
        let typeFinitura = $(this).attr('data-type');
        let previewFinitura = $(this).attr('data-preview');
        $('#'+typeFinitura).find('.default-finitura').hide();
        $('#'+typeFinitura).find('.extra-finitura').hide();
        $('#'+typeFinitura).find('#'+previewFinitura).show();
    });
});
/*$('.has-preview').mouseover(function (){
    var typeFinitura = $(this).attr('data-type');
    let previewFinitura = $(this).attr('data-preview');
    $('#'+typeFinitura).find('.default-finitura').hide();
    $('#'+typeFinitura).find('.extra-finitura').hide();
    $('#'+typeFinitura).find('#'+previewFinitura).show();
}).mouseleave(function (){
    $('.extra-finitura').hide();
    $('.default-finitura').show();
})*/

$('.single-preview_finitura_stile').each(function (el) {
    $(this).click(function (){
        let typeFinitura = $(this).attr('data-type');
        let previewFinitura = $(this).attr('data-preview');
        $('#'+typeFinitura).find('.default-finitura').hide();
        $('#'+typeFinitura).find('.single_campione').hide();
        $('#'+typeFinitura).find('#'+previewFinitura).show();
    });
});


$(document).on('click', '#js-open-search', function (e){
    e.preventDefault();
    $('.form-search').toggleClass('show');
    $('#query').focus();
});

$(document).on('click', '#js-search-close', function (e){
    e.preventDefault();
    $('.form-search').removeClass('show');
});

document.addEventListener('DOMContentLoaded', function() {
    var popup = document.getElementById('popup');
    var overlay = document.querySelector('.overlay-popup');
    if (popup) {
        var cookieName = 'popup';
        var cookieValue = 'shown';
        var cookieExpires = 1; // 1 day
        if (document.cookie.indexOf(cookieName) === -1) {
            popup.classList.remove('d-none');
            overlay.classList.remove('d-none');
            //document.cookie = cookieName + '=' + cookieValue + ';max-age=' + 60 * 60 * 24 * cookieExpires + ';path=/';
        }

        var popupClose = document.querySelector('#popup .popup-close');
        var popupLink = document.querySelectorAll('#popup .popup-link');

        if (popupClose) {
            popupClose.addEventListener('click', function() {
                document.cookie = cookieName + '=' + cookieValue + ';max-age=' + 60 * 60 * 24 * cookieExpires + ';path=/'; // durata 1 giorno
                //document.cookie = cookieName + '=' + cookieValue + ';max-age=600' + ';path=/'; // durata 10 minuti
                popup.classList.add('d-none');
                overlay.classList.add('d-none');
            });
        }

        if (popupLink) {
            $('#popup .popup-link').click(function (){
                document.cookie = cookieName + '=' + cookieValue + ';max-age=' + 60 * 60 * 24 * cookieExpires + ';path=/'; // durata 1 giorno
                //document.cookie = cookieName + '=' + cookieValue + ';max-age=600' + ';path=/'; // durata 10 minuti
                popup.classList.add('d-none');
                overlay.classList.add('d-none');
            });
            /*popupLink.addEventListener('click', function() {
                //document.cookie = cookieName + '=' + cookieValue + ';max-age=' + 60 * 60 * 24 * cookieExpires + ';path=/'; // durata 1 giorno
                document.cookie = cookieName + '=' + cookieValue + ';max-age=600' + ';path=/'; // durata 10 minuti
                popup.classList.add('d-none');
                overlay.classList.add('d-none');
            });*/
        }
    }

    if($('.white-popup').innerHeight() < window.innerHeight) {
        $('.white-popup').addClass('fixed');
    } else {
        $('.white-popup').removeClass('fixed');
    }

});

var newsGallerySlider = $('.gallery-detail-news');
newsGallerySlider.owlCarousel({
    loop: true,
    margin: 0,
    nav: true,
    dots: false,
    autoplay: false,
    items: 1
});

$(document).ready(function() {
    if ($(window).width() < 640) {
        $('video').remove();
    }

    if($('.news-body').length > 0) {
        $('p').each(function () {
            const $p = $(this);
            if (
                $p.find('img').length === 1 &&
                $.trim($p.clone().children('img, a').remove().end().text()) === ''
            ) {
                $p.replaceWith($p.contents());
            }
        });
    }
});

$('input[name="consenso"]').change(function (e){
    if(e.currentTarget.value=="Si"){
        $('.nl_type').slideDown();
    }else{
        $('.nl_type').slideUp();
    }
})

if($('#form-consenso-newsletter').length > 0) {
    document.getElementById("form-consenso-newsletter").addEventListener("submit", function (e) {

        const consensoSi = document.querySelector('input[name="consenso"][value="Si"]:checked');
        const checkboxes = document.querySelectorAll('.nl_type input[type="checkbox"]:checked');

        // Se ha dato il consenso
        if (consensoSi) {
            // Controllo: almeno una checkbox selezionata
            if (checkboxes.length === 0) {
                e.preventDefault(); // blocca invio form
                alert("Se dai il consenso, devi selezionare almeno una newsletter.");
            }
        }
    });
}
